<template>
  <div id="app-setting">
    <vs-tabs position="left" class="app-setting appointment-setting" id="app-settings">
      <vs-tab label="Web booking settings">
        <vx-card class="shadow-md">
          <h2 class="mb-6">Web booking settings</h2>
          <!-- <div class="flex align-center">
            <vs-switch
              v-model="key_active_web_booking"
              class="my-6"
              @click="updateActive('web_booking')"
            />
            <span class="pl-5">
              Please press "Activate" only when you have completed all information in Setting, Services and Staff tabs.
              After you hit "Activate", all information will officially appear on your online booking and customers can start booking with your business.
            </span>
          </div>
          <div class="flex align-center">
            <vs-switch v-model="key_active" class="my-6" @click="updateActive('show_price')" />
            <span class="pl-5">Show service price on your online booking page</span>
          </div> -->
          <div class="flex align-center">
            <vs-switch v-model="key_skip_btn" class="my-6" @click="updateActive('show_skip')" />
            <span class="pl-5">Show skip button on your online booking page</span>
          </div>
          <div class="flex align-center">
            <vs-switch v-model="key_any_staff" class="my-6" @click="updateActive('any_staff')" />
            <span
              class="pl-5"
            >"Any Staff" option will be used when your customer doesn't know who to book online.</span>
          </div>
          <transition name="list">
            <div class="flex align-center" v-if="key_any_staff">
              <vs-switch v-model="key_auto_assign" class="my-6" @click="updateActive('auto_assign')" />
              <span
                class="pl-5"
              >Appointment will be assigned automatically by the system to any staff available that time and can do the service.</span>
            </div>
          </transition>
          <div class="flex align-center ml-base pl-base">
            <span class="select-color-title">Any staff color: </span>
            <!-- <div class="position-relative overflow-hidden rounded-lg ml-4" style="border: 1px solid #ddd;">
              <input class="w-10 cursor-pointer h-10" v-model="any_staff_color" type="color" @change="updateActive('any_staff_color')" />
              <div class="w-full h-full pointer-events-none" style="position: absolute; top: 0; left: 0;" :style="`background: ${any_staff_color}`"></div>
            </div> -->
            <div class="ml-4 position-relative" :key="any_staff_color_key">
              <div class="tooltip" @click.stop>
                <vs-button class="select-color-btn" @click.stop>
                  <div class="rounded-lg selected-color" :style="`background: ${any_staff_color}`" :class="{'bg-colorful' : any_staff_color == '#FFFFFF'}"></div>
                  <span class="tooltiptext" style="word-wrap: break-word; word-break: break-word;">
                    <div class="position-relative rounded-lg item-action" v-for="(color, index) in themeColorsAnyStaff" :key="index" :style="`background: ${color}`" :class="{'pointer-events-none cursor-default': color == any_staff_color, 'bg-colorful': color == '#FFFFFF'}" @click.stop="updateActive('any_staff_color', color)">
                      <i class="vs-icon material-icons text-white font-bold text-2xl translate-center" v-if="color == any_staff_color">check</i>
                    </div>
                  </span>
                </vs-button>
              </div>
            </div>
          </div>

          <div class="flex align-center ml-base pl-base my-3">
            <span class="select-color-title">Booking done color: </span>
            <!-- <div class="position-relative overflow-hidden rounded-lg ml-4" style="border: 1px solid #ddd;">
              <input class="w-10 cursor-pointer h-10" v-model="any_staff_color" type="color" @change="updateActive('any_staff_color')" />
              <div class="w-full h-full pointer-events-none" style="position: absolute; top: 0; left: 0;" :style="`background: ${any_staff_color}`"></div>
            </div> -->
            <div class="ml-4 position-relative" :key="booking_done_color_key">
              <div class="tooltip" @click.stop>
                <vs-button class="select-color-btn" @click.stop>
                  <div class="rounded-lg selected-color" :style="`background: ${booking_done_color}`"></div>
                  <span class="tooltiptext" style="word-wrap: break-word; word-break: break-word;">
                    <div class="position-relative rounded-lg item-action" v-for="(color, index) in themeColorsAppointment" :key="index" :style="`background: ${color}`" :class="{'pointer-events-none cursor-default': color == booking_done_color}" @click.stop="updateActive('booking_done_color', color)">
                      <i class="vs-icon material-icons text-white font-bold text-2xl translate-center" v-if="color == booking_done_color">check</i>
                    </div>
                  </span>
                </vs-button>
              </div>
            </div>
          </div>

          <div class="flex align-center ml-base pl-base">
            <span class="select-color-title">Booking cancel color: </span>
            <!-- <div class="position-relative overflow-hidden rounded-lg ml-4" style="border: 1px solid #ddd;">
              <input class="w-10 cursor-pointer h-10" v-model="any_staff_color" type="color" @change="updateActive('any_staff_color')" />
              <div class="w-full h-full pointer-events-none" style="position: absolute; top: 0; left: 0;" :style="`background: ${any_staff_color}`"></div>
            </div> -->
            <div class="ml-4 position-relative" :key="booking_cancel_color_key">
              <div class="tooltip" @click.stop>
                <vs-button class="select-color-btn" @click.stop>
                  <div class="rounded-lg selected-color" :style="`background: ${booking_cancel_color}`"></div>
                  <span class="tooltiptext" style="word-wrap: break-word; word-break: break-word;">
                    <div class="position-relative rounded-lg item-action" v-for="(color, index) in themeColorsAppointment" :key="index" :style="`background: ${color}`" :class="{'pointer-events-none cursor-default': color == booking_cancel_color}" @click.stop="updateActive('booking_cancel_color', color)">
                      <i class="vs-icon material-icons text-white font-bold text-2xl translate-center" v-if="color == booking_cancel_color">check</i>
                    </div>
                  </span>
                </vs-button>
              </div>
            </div>
          </div>

          <!-- <p class="font-bold mt-3 mb-2">Activate web booking</p> -->
          <vs-appointment-setting class="mt-6"></vs-appointment-setting>
          <!-- <p class="font-bold mt-6">Service Price shown online</p> -->
          <vs-appointment-active-price class="mt-2 mb-5"></vs-appointment-active-price>
          <!-- <p class="font-bold mt-4 mb-2">Skip Owner's Confirmation</p> -->
          <skip-owner-confirmation class="mb-2"></skip-owner-confirmation>

          <div class="flex align-center">
            <vs-switch v-model="hide_unassigned_no_booking" class="my-6" @click="updateActive('hide_unassigned_no_booking')" />
            <span class="pl-5">Hide unassigned column when having no appointment</span>
          </div>
        </vx-card>
      </vs-tab>

      <!-- <vs-tab label="Other settings">
        <vx-card class="shadow-md">
          <h2 class="mb-6">Other settings</h2>
          <p class="font-bold mt-3 mb-2">Activate web booking</p>
          <vs-appointment-setting></vs-appointment-setting>
          <p class="font-bold mt-6">Service Price shown online</p>
          <vs-appointment-active-price></vs-appointment-active-price>
          <p class="font-bold mt-4 mb-2">Skip Owner's Confirmation</p>
          <skip-owner-confirmation></skip-owner-confirmation>
        </vx-card>
      </vs-tab> -->

      <vs-tab label="Booking Hours">
        <booking-working-hour></booking-working-hour>
      </vs-tab>

      <vs-tab label="Appointment Deposit">
        <appointment-deposit-setting></appointment-deposit-setting>
      </vs-tab>

      <!-- <vs-tab label="Activate web booking">
        <vs-appointment-setting></vs-appointment-setting>
      </vs-tab> -->
    </vs-tabs>
  </div>
</template>
<script>
import BookingWorkingHour from './BookingWorkingHour';
import AppointmentDepositSetting from './AppointmentDepositSetting';
export default {
  components: {
    BookingWorkingHour,
    AppointmentDepositSetting
  },
  data() {
    return {
      key_active: false,
      key_skip_btn: false,
      key_any_staff: false,
      key_auto_assign: false,
      key_active_web_booking: false,
      hide_unassigned_no_booking: false,
      type_err: "",
      loaded_data_num: 0,
      action_type: "",
      any_staff_color: "#71ABDD",
      booking_done_color: "#3a87ad",
      booking_cancel_color: "#FF0000",
      themeColorsAnyStaff: this.$store.getters["staffList/themeColorsAnyStaff"],
      themeColorsAppointment: this.$store.getters["staffList/themeColorsAppointment"],
      any_staff_color_key: 0,
      booking_done_color_key: 0,
      booking_cancel_color_key: 0
    };
  },
  methods: {
    openLoadingInDiv() {
      this.$vs.loading({
        container: "#app",
        scale: 0.8
      });
      if (this.loadTime) {
        clearTimeout(this.loadTime);
        this.loadTime = null;
      }
      this.isOpenLoading = true;
      this.loadTime = setTimeout(() => {
        if (this.isOpenLoading) {
          this.closeLoading();
          this.$vs.dialog({
            color: "danger",
            title: "Notification",
            text: this.action_type + " Failed",
            acceptText: "OK"
          });
        }
      }, 10000);
    },
    closeLoading() {
      this.isOpenLoading = false;
      setTimeout(() => {
        this.$vs.loading.close("#app > .con-vs-loading");
      }, 500);
    },
    updateActive(type, color = null) {
      let obj = {};
      if (type == "show_price") {
        this.action_type = "Update Show Booking Service Price";
        obj = {
          key: "config.service.show_price",
          value: !this.key_active ? 1 : 0
        };
      } else if (type == "show_skip") {
        this.action_type = "Update Show Skip Button";
        obj = {
          key: "config.appointment.web_booking.skip_staff.active",
          value: !this.key_skip_btn ? 1 : 0
        };
      } else if (type == "web_booking") {
        this.action_type = "Update Web Booking Status";
        obj = {
          key: "module.appointment.active",
          value: !this.key_active_web_booking ? 1 : 0
        };
      } else if (type == "any_staff") {
        this.action_type = "Update Default Staff Select";
        obj = {
          key: "module.appointment.any_staff",
          value: !this.key_any_staff ? 1 : 0
        };
      } else if (type == "any_staff_color") {
        this.action_type = "Update Any Staff Color";
        obj = {
          key: "appointment.any_staff.color_code",
          value: color 
        };
      } else if (type == "booking_done_color") {
        this.action_type = "Update Booking Done Color";
        obj = {
          key: "appointment.appointment_event.done.color_code",
          value: color 
        };
      } else if (type == "booking_cancel_color") {
        this.action_type = "Update Booking Cancel Color";
        obj = {
          key: "appointment.appointment_event.cancel.color_code",
          value: color 
        };
      } else if (type == "hide_unassigned_no_booking") {
        this.action_type = "Update Hide Unassigned No Booking";
        obj = {
          key: "appointment.calendar.hide_unassigned_no_booking",
          value: !this.hide_unassigned_no_booking ? 1 : 0 
        };
      } else {
        this.action_type = "Update Auto Assign";
        obj = {
          key: "module.appointment.any_staff.auto_assign",
          value: !this.key_auto_assign ? 1 : 0
        };
      }
      // this.action_type = "Update";
      this.openLoadingInDiv();
      this.$store
        .dispatch("appSetting/UPDATE_KEY_STORAGE", obj)
        .then(() => {
          this.closeLoading();
          if(type == "any_staff_color") {
            this.any_staff_color = color;
            this.any_staff_color_key++;
          }
          if(type == "booking_done_color") {
            this.booking_done_color = color;
            this.booking_done_color_key++;
          }
          if(type == "booking_cancel_color") {
            this.booking_cancel_color = color;
            this.booking_cancel_color_key++;
          }
          this.$vs.notify({
            title: "Notification",
            text: this.action_type + " Success",
            color: "success",
            position: "top-right"
          });
        })
        .catch(() => {
          this.$vs.notify({
            title: "Notification",
            text: this.action_type + " Failed",
            color: "danger",
            position: "top-right"
          });
        });
    }
  },
  async created() {
    this.openLoadingInDiv();

    //========================================================== BOOKING ACTIVE =================================================================
    const web_booking_active = {
      key: "module.appointment.active"
    };

    await this.$store
      .dispatch("appSetting/GET_KEY_STORAGE", web_booking_active)
      .then(res => {
        this.loaded_data_num++;
        //   this.$emit('LoadDataComplete');
        // appointment = this.$store.getters["appSetting/keyStorage"];
        this.key_active_web_booking = res.value == 1 ? true : false;
      })
      .catch(() => {
        const obj = {
          key: "module.appointment.active",
          value: 0
        };
        this.$store.dispatch("appSetting/ADD_KEY_STORAGE", obj).then(() => {
          this.loaded_data_num++;
        });
      });

    //========================================================== SHOW PRICE=================================================================

    const obj = {
      key: "config.service.show_price"
    };

    await this.$store
      .dispatch("appSetting/GET_KEY_STORAGE", obj)
      .then(rs => {
        this.loaded_data_num++;
        //   this.$emit('LoadDataComplete');
        // let appointment = {};
        // appointment = this.$store.getters["appSetting/keyStorage"];
        this.key_active = rs.value == 1 ? true : false;
      })
      .catch(() => {
        const obj = {
          key: "config.service.show_price",
          value: 0
        };
        this.$store.dispatch("appSetting/ADD_KEY_STORAGE", obj).then(() => {
          this.loaded_data_num++;
        });
      });

    //========================================================== ANY STAFF =================================================================

    const any_staff_data = {
      key: "module.appointment.any_staff"
    };

    await this.$store
      .dispatch("appSetting/GET_KEY_STORAGE", any_staff_data)
      .then(rs => {
        this.loaded_data_num++;
        // let appointment = {};
        this.key_any_staff = rs.value == 1 ? true : false;
      })
      .catch(() => {
        const any_staff_data = {
          key: "module.appointment.any_staff",
          value: 0
        };
        this.$store
          .dispatch("appSetting/ADD_KEY_STORAGE", any_staff_data)
          .then(() => {
            this.loaded_data_num++;
          });
      });

    //========================================================== AUTO ASSIGN =================================================================

    const auto_assign_data = {
      key: "module.appointment.any_staff.auto_assign"
    };

    await this.$store
      .dispatch("appSetting/GET_KEY_STORAGE", auto_assign_data)
      .then(rs => {
        this.loaded_data_num++;
        // let appointment = {};
        this.key_auto_assign = rs.value == 1 ? true : false;
      })
      .catch(() => {
        const auto_assign_data = {
          key: "module.appointment.any_staff.auto_assign",
          value: 0
        };
        this.$store
          .dispatch("appSetting/ADD_KEY_STORAGE", auto_assign_data)
          .then(() => {
            this.loaded_data_num++;
          });
      });

    //========================================================== SKIP BUTTON =================================================================

    const skip_btn_data = {
      key: "config.appointment.web_booking.skip_staff.active"
    };

    await this.$store
      .dispatch("appSetting/GET_KEY_STORAGE", skip_btn_data)
      .then(rs => {
        this.loaded_data_num++;
        // let appointment = {};
        this.key_skip_btn = rs.value == 1 ? true : false;
      })
      .catch(() => {
        const skip_btn_data = {
          key: "config.appointment.web_booking.skip_staff.active",
          value: 0
        };
        this.$store
          .dispatch("appSetting/ADD_KEY_STORAGE", skip_btn_data)
          .then(() => {
            this.loaded_data_num++;
          });
      });

    //========================================================== ANY STAFF COLOR =================================================================

    const any_staff_color_data = {
      key: "appointment.any_staff.color_code"
    };

    await this.$store
      .dispatch("appSetting/GET_KEY_STORAGE", any_staff_color_data)
      .then(rs => {
        this.loaded_data_num++;
        this.any_staff_color = rs.value ? rs.value : '#71ABDD';
      })
      .catch(() => {
        const any_staff_color_data = {
          key: "appointment.any_staff.color_code",
          value: '#71ABDD'
        };
        this.$store
          .dispatch("appSetting/ADD_KEY_STORAGE", any_staff_color_data)
          .then(() => {
            this.loaded_data_num++;
          });
      });

    //========================================================== BOOKING DONE COLOR =================================================================

    const booking_done_color_data = {
      key: "appointment.appointment_event.done.color_code"
    };

    await this.$store
      .dispatch("appSetting/GET_KEY_STORAGE", booking_done_color_data)
      .then(rs => {
        this.loaded_data_num++;
        this.booking_done_color = rs.value ? rs.value : '#3a87ad';
      })
      .catch(() => {
        const booking_done_color_data = {
          key: "appointment.appointment_event.done.color_code",
          value: '#3a87ad'
        };
        this.$store
          .dispatch("appSetting/ADD_KEY_STORAGE", booking_done_color_data)
          .then(() => {
            this.loaded_data_num++;
          });
      });
    
    //========================================================== BOOKING CANCEL COLOR =================================================================

    const booking_cancel_color_data = {
      key: "appointment.appointment_event.cancel.color_code"
    };

    await this.$store
      .dispatch("appSetting/GET_KEY_STORAGE", booking_cancel_color_data)
      .then(rs => {
        this.loaded_data_num++;
        this.booking_cancel_color = rs.value ? rs.value : '#FF0000';
      })
      .catch(() => {
        const booking_cancel_color_data = {
          key: "appointment.appointment_event.cancel.color_code",
          value: '#FF0000'
        };
        this.$store
          .dispatch("appSetting/ADD_KEY_STORAGE", booking_cancel_color_data)
          .then(() => {
            this.loaded_data_num++;
          });
      });

    //========================================================== HIDE UNASSIGNED NO BOOKING  =================================================================

    const hide_unassigned_no_booking_data = {
      key: "appointment.calendar.hide_unassigned_no_booking"
    };

    await this.$store
      .dispatch("appSetting/GET_KEY_STORAGE", hide_unassigned_no_booking_data)
      .then(rs => {
        this.loaded_data_num++;
        // let appointment = {};
        this.hide_unassigned_no_booking = rs.value == 1 ? true : false;
      })
      .catch(() => {
        const hide_unassigned_no_booking_data = {
          key: "appointment.calendar.hide_unassigned_no_booking",
          value: 0
        };
        this.$store
          .dispatch("appSetting/ADD_KEY_STORAGE", hide_unassigned_no_booking_data)
          .then(() => {
            this.loaded_data_num++;
          });
      });

    await this.closeLoading();
  }
};
</script>